import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Check } from 'lucide-react';

export function SubscriptionSuccessPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  useEffect(() => {
    queryClient.invalidateQueries({ queryKey: ['subscriptions', 'current'] });

    const timeout = setTimeout(() => {
      navigate('/settings/subscription', { replace: true });
    }, 4000);

    return () => clearTimeout(timeout);
  }, [navigate, queryClient]);

  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <Card className="max-w-md w-full text-center">
        <CardHeader>
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-success/10">
            <Check className="h-8 w-8 text-success" />
          </div>
          <CardTitle>{t('subscription.success.title')}</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            {t('subscription.success.description')}
          </p>
          <p className="text-sm text-muted-foreground mt-4">
            {t('subscription.success.redirect')}
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
